__turbopack_context__.v({
  "h1": "oqvZeq_h1",
  "h1_opt": "oqvZeq_h1_opt",
  "h2": "oqvZeq_h2",
  "h2Small": "oqvZeq_h2Small",
  "h2_opt": "oqvZeq_h2_opt",
  "h3": "oqvZeq_h3",
  "leftSideTextWrapper": "oqvZeq_leftSideTextWrapper",
  "p": "oqvZeq_p",
  "pBody": "oqvZeq_pBody",
  "pLarge": "oqvZeq_pLarge",
  "pLargeGradient": "oqvZeq_pLargeGradient",
  "p_opt": "oqvZeq_p_opt",
});
